import { useEffect, useState } from "react";
import globalRequest from "../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import { CATEGORIES } from "../../utils/helper/Enum";
import * as CUSTOM from "../../utils/helper/custom";
import MenuItems from "components/MenuBar/MenuItems";
import { Button, Img } from "components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  updateCategories,
  getAllCategories,
} from "../../redux/reducers/allCategories";
import { storageKeys } from "utils/global/localData";
import { changeTrigger } from "redux/reducers/trigger";
import { useAppFont } from "../../utils/helper/useAppFont";
const NavMenu = (props) => {
  const dispatch = useDispatch();
  const [menuItems, setMenuItem] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const getAllCatData = useSelector(getAllCategories);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const loginData = CUSTOM.loginData();
  const isLoggedIn = !!loginData?.id;
  const userName = loginData?.firstName || "";

  const userFullName = loginData?.name || loginData?.firstName || "";
  const userMobile = loginData?.mobileNo || "";
  const userInitials = userFullName
    ? userFullName.substring(0, 2).toUpperCase()
    : userName
    ? userName.substring(0, 2).toUpperCase()
    : "RA";
  const { interClass, headingClass, interFamily, headingFamily } = useAppFont();

  /**
   *  Get category list
   */
  const getAllCategoriesList = async () => {
    try {
      //dispatch(changeLoader(true));
      let response = await globalRequest(
        CATEGORIES?.GET_ALL_CATEGORIES,
        "get",
        {},
        {},
        true
      );

      response = response?.data;

      if (response?.status === "SUCCESS") {
        const categories = response?.data || [];
        const categoriesWithUrls = categories.map((mainCat) => {
          const mainSlug = mainCat.slug;
          const mainUrl = `/${mainSlug}`;

          const subcategories = mainCat.subcategories?.map(subCat => {
            const subSlug = `${mainSlug}/${subCat.slug}`;
            const subUrl = `/${subSlug}`;

            const subsubcategories = subCat.subsubcategories?.map(subSubCat => ({
              ...subSubCat,
              fullUrl: `/${subSlug}/${subSubCat.slug}`
            })) || [];

            return {
              ...subCat,
              fullUrl: subUrl,
              subsubcategories,
            };
          }) || [];

          return {
            ...mainCat,
            fullUrl: mainUrl,
            subcategories,
          };
        });
        dispatch(updateCategories(categoriesWithUrls));
      }

      dispatch(changeLoader(false));
    } catch (e) { }
  };

  const handleLogout = () => {
    localStorage.removeItem(storageKeys.USER_TOKEN);
    localStorage.removeItem(storageKeys.DEVICE_ID);

    localStorage.removeItem(storageKeys.CART_DATA);
    localStorage.removeItem(storageKeys.CART_COUNTER);
    localStorage.removeItem("custom_cake_completed");
    localStorage.removeItem("custom_cake_images");
    localStorage.removeItem("custom_cake_message");
    localStorage.removeItem("custom_cake_price");
    localStorage.removeItem("custom_cake_quantities");
    localStorage.removeItem("custom_cake_reference");
    localStorage.removeItem("custom_cake_selected");
    localStorage.removeItem("custom_cake_step");
    localStorage.removeItem("custom_cake_text");
    localStorage.removeItem("custom_cake_shape");

    dispatch(changeTrigger("loggedout"));
    window.location.href = "/";
  };

  const closeMenu = () => {
    if (props?.handlehamburger) {
      props.handlehamburger();
    }
  };

  // const navigate = useNavigate();

  
  let urlPath = '';
  const handleCategoryClick = (category) => {
    urlPath = category;
    navigate(category);
    // closeMenu();
    
  };


  useEffect(() => {
    if (getAllCatData.length == 0) {
      getAllCategoriesList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const processCategories = (categories, parentSlug = "", isFromMore = false) => {
      return categories.map((item) => {
        const slugPath = parentSlug ? `${parentSlug}/${item.slug}` : item.slug;
        const url = `/productlist/${slugPath}/${item.id}`;
        const itemProductCount = Number(item?.productCount || 0);
        if (isFromMore && itemProductCount === 0) {
          return null;
        }

        const mainObj = {
          title: CUSTOM.toTitleCase(CUSTOM.getdataByLangKey(item?.categoryLocales, "", "name")),
          url,
          id: item?.id,
          isTopLevel: true,
          isFromMore,
          productCount: isFromMore ? itemProductCount : 0,
        };

        if (item?.subcategories?.length > 0) {
          mainObj.submenu = item.subcategories.map((sitem) => {
            const sitemProductCount = Number(sitem?.productCount || 0);
              
              if (sitemProductCount === 0) {
                return null;
              }
            const subObj = {
              title: CUSTOM.toTitleCase(CUSTOM.getdataByLangKey(sitem?.categoryLocales, "", "name")),
              url: sitem?.parentId > 0 ? `/productlist/${slugPath}/${sitem?.slug}/${sitem?.id}` : "",
              id: sitem?.id,
              isTopLevel: false,
              isFromMore: false,
              image: sitem?.categoryImages?.[0]?.Image || item?.categoryImages?.[0]?.Image || "",
              productCount: sitemProductCount,
            };

            if (sitem?.subsubcategories?.length > 0) {
              subObj.submenu = sitem.subsubcategories.map((ssitem) => ({
                title: CUSTOM.toTitleCase(CUSTOM.getdataByLangKey(ssitem?.categoryLocales, "", "name")),
                url: ssitem?.parentId > 0 ? `/productlist/${slugPath}/${sitem?.slug}/${ssitem?.slug}/${ssitem?.id}` : "",
                id: ssitem?.id,
                isTopLevel: false,
                isFromMore: false,
                productCount: Number(ssitem?.productCount || 0),
              }));
            }

            return subObj;
          }).filter(Boolean);
        }

        return mainObj;
      }).filter(Boolean);
    };

    const isMobile = windowWidth < 768;
    let allMenuItems = [];

  if (getAllCatData.length > 0) {
    if (isMobile) {
      allMenuItems = processCategories(getAllCatData, "", false);
    } else {
      allMenuItems = processCategories(getAllCatData.slice(0, 5), "", false);
    if (getAllCatData.length > 5) {
      allMenuItems.push({
        title: t("more"),
        url: "",
        id: 0,
        icon: true,
        submenu: processCategories(getAllCatData.slice(5), "", true),
      });
    }
    }
  }

    setMenuItem(allMenuItems);
  }, [getAllCatData, windowWidth, t]);
  return (
    <>
      <nav className={`${props.navStyles} flex flex-row mobile-menu-parent`}>
        <div className="sm:block hidden flex-col mx-auto gap-2">
          {/* {!isLoggedIn ? (
            <>
              <h3 className={`text-sm font-bold ${interClass} sm:${interClass} text-[#1A1A1A]`}>{t("welcomeBack")}</h3>
              <p className={`text-[#3E4147] text-sm sm:${interClass} font-normal`}>{t("signInToTrackYourOrdersAndSaveYourFavorites")}</p>
              <Button
                className="sm:block hidden text-center h-[48px] w-full border border-[#E6E6E6] bg-white my-3 p-2 rounded-full text-[#1A1A1A] font-[Unbounded] font-medium text-[14px] cursor-pointer"
                onClick={() => navigate("/login")}
              >
                {t("Signup_Login")}
              </Button>
            </>
          ) : (
            <h3 className="sm:font-[Unbounded] font-semibold sm:font-[16px]">
            </h3>
          )} */}
        </div>

        {/* Mobile only */}
        <div className="hidden sm:block w-[90%] mb-4 flex-col mx-auto gap-2">
          {!isLoggedIn ? (
            <>
              <h3 className={`text-sm font-bold  text-[#1A1A1A] ${interClass}`}>{t("welcomeBack")}</h3>
              <p className={`text-[#3E4147] text-sm font-normal ${interClass} mt-1`}>{t("signInToTrackYourOrdersAndSaveYourFavorites")}</p>
              <Button
                className={`text-center h-[48px] w-full border border-[#E6E6E6] bg-[white] my-3 p-2 rounded-full text-[#1A1A1A] ${headingClass} font-medium text-[14px] cursor-pointer`}
                onClick={() => { navigate("/login"); closeMenu(); }}
              >
                {t("Signup_Login")}
              </Button>
            </>
          ) : (
            <>
              <div className="flex items-center justify-between w-full px-1 py-2 bg-[#FEFBFC]">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-pink-100 flex items-center justify-center flex-shrink-0">
                    <span className={`text-[#771237] font-bold text-sm ${interClass}`}>
                      {userInitials}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className={`text-[16px] font-semibold text-[#1A1A1A] ${interClass} leading-[24px]`}>
                      {userFullName || userName}
                    </span>
                    {userMobile && (
                      <span className={`text-[14px] text-[#727783] ${interClass} mt-0.5`}>
                        {userMobile}
                      </span>
                    )}
                  </div>
                </div>
                <button
                  onClick={() => navigate("/my-order")}
                  className="w-8 h-8 flex items-center justify-center border border-gray-400 rounded-full hover:bg-gray-100 transition-all"
                >
                  <Img src="images/editIcon.svg" alt="editIcon" className="h-5 w-5 object-cover" />
                </button>
              </div>

              <button
                onClick={() => { navigate("/my-order"); closeMenu(); }}
                className={`
                  w-full
                  mt-2
                  h-[44px]
                  rounded-full
                  border border-[#E6E6E6]
                  bg-[white]
                  text-[#1A1A1A]
                  ${headingClass}
                  text-[14px]
                  font-medium
                  hover:bg-gray-50
                  transition-all
                  duration-200
                `}
              >
                {t("manageProfile") || "Manage Profile"}
              </button>

              <div className="w-full h-[1px] bg-[#E6E6E6] mt-4" />
            </>
          )}
        </div>
        <ul className="menus overflow-visible sm:max-w-[100%]">
          {menuItems.map((menu, index) => {
            const depthLevel = 0;
            return (
              <div key={index} className="sm:w-full sm:relative sm:z-40">
              <MenuItems
                handlehamburger={props.handlehamburger}
                items={menu}
                key={index}
                depthLevel={depthLevel}
                handleCategoryClick={handleCategoryClick}
                urlPath={urlPath}
                isMoreItem={menu.title === t("more")}
              />
              </div>
            );
          })}
        </ul>
        {isLoggedIn && (
          <div className="sm:block hidden mt-6 w-full flex justify-center">
            <button
              onClick={() => {
                closeMenu();
                handleLogout();
              }}
              className={`
                w-full
                h-[44px]
                rounded-full
                bg-[#771237]
                ml-2
                text-[white]
                ${headingClass}
                text-[16px]
                font-semibold
                shadow-md
                transition-all
                duration-200
                active:scale-[0.98]
              `}
            >
              {t("Logout")}
            </button>
          </div>
          )}
      </nav>
    </>
  );
};

export { NavMenu };
